import styles from './ProgressAnime.module.scss';

function ProgressAnime() {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.loader}></div>
    </div>
  );
}

export default ProgressAnime;
